import * as ActiveStorage from "@rails/activestorage"
import "../controllers"

ActiveStorage.start()